import { getMetaValueFromKey } from "@cappelendamm/crystallize-utils";
import { SUBSCRIPTION_CONTRACT_META_KEY } from "../constants.js";
import { getPeriodsToSkip } from "../selectors/getPeriodsToSkip.js";
import { getContractSelectedGifts } from "../selectors/meta.js";
/**
 * What a contract says about its own delivery: the pending skip, the dispatch
 * batch it belongs to, the sign-up gifts it chose, and whether those gifts are
 * still the next thing on their way. The membership page and the membership
 * card both resolve their delivery from this, so they cannot disagree.
 */
export const getContractDeliveryInput = ({ meta, isBookClub, giftConfig, lastReceivedBookSku, }) => {
    const receivedGifts = getMetaValueFromKey(meta, SUBSCRIPTION_CONTRACT_META_KEY.HAS_RECEIVED_GIFTS);
    return {
        periodsToSkip: getPeriodsToSkip(meta),
        dispatchBatchCode: isBookClub
            ? getMetaValueFromKey(meta, SUBSCRIPTION_CONTRACT_META_KEY.DISPATCH_BATCH_CODE)
            : undefined,
        holdbackUntil: isBookClub
            ? getMetaValueFromKey(meta, SUBSCRIPTION_CONTRACT_META_KEY.HOLDBACK_UNTIL)
            : undefined,
        gifts: getContractSelectedGifts({ meta }),
        receivedGifts,
        isGiftCampaign: giftConfig.count > 0,
        isWithoutCreatedOrders: !lastReceivedBookSku && receivedGifts !== "true",
    };
};
